var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg10(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 97,
    viewBox: "0 0 90 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.99
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.3137 29.936H22.3783L35.8335 71.2173L43.3661 47.8542L37.526 29.936H32.3187V26.0025H55.3782V29.936H49.9782L63.4332 71.2173L68.2698 56.2159C74.6144 36.9964 63.0697 31.0094 63.0697 26.7201C63.0697 22.4308 66.2734 18.9538 70.2252 18.9538C70.439 18.9538 70.6466 18.9664 70.8501 18.987C64.1541 12.1264 55.1252 7.91919 45.1902 7.91919C32.2085 7.91919 20.7737 15.1011 14.0703 26.0025H27.3133V29.936H27.3137Z",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.80469 48.4997C7.80469 64.0362 15.8504 77.5312 27.665 84.3504L10.7918 32.5825C8.86974 37.4699 7.80469 42.8497 7.80469 48.4997Z",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.7313 28.5029C78.2661 31.9208 78.1042 35.7622 77.2835 39.6186H77.4322L76.8668 41.3719C76.5318 42.638 76.11 43.933 75.6309 45.2056L62.7656 84.3244C74.5555 77.4969 82.5806 64.0165 82.5806 48.4997C82.5806 41.2287 80.817 34.4054 77.7313 28.5029Z",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6641 87.1106C37.2964 88.3877 41.1709 89.0804 45.1954 89.0804C49.034 89.0804 52.737 88.4516 56.223 87.2853L45.2862 53.7305L33.6641 87.1106Z",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.7909 14.2052C68.3509 5.04486 57.1293 0 45.1933 0C33.2573 0 22.0358 5.04486 13.5959 14.2052C5.15591 23.3656 0.507812 35.545 0.507812 48.5C0.507812 61.4548 5.15591 73.6341 13.5959 82.7945C22.0358 91.9549 33.2575 96.9998 45.1935 96.9998C57.1295 96.9998 68.3509 91.9549 76.7911 82.7945C85.2311 73.6341 89.8792 61.4546 89.8792 48.5C89.879 35.545 85.2309 23.3656 76.7909 14.2052ZM45.1933 93.5785C22.2918 93.5785 3.66005 73.3564 3.66005 48.5C3.66005 23.6436 22.2918 3.42131 45.1933 3.42131C68.0948 3.42131 86.7265 23.6436 86.7265 48.5C86.7265 73.3564 68.095 93.5785 45.1933 93.5785Z",
    fill: "#212121"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg10);
export default __webpack_public_path__ + "static/media/10.91d83bd856464fd96c0997f2479b44dc.svg";
export { ForwardRef as ReactComponent };